
import { Injectable } from '@angular/core';
import { Effect, Actions, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { AppState } from '../reducers';
import {SaveCategories,CategoryActions, PriceLevelActions} from '../actions';
import { MessageActions} from '../actions/message.actions';

import {CategoryApi,HttpClient,PriceApi} from '../services/webservice';
import {Category,PriceLevel } from '../models';
import {CombinedPriceLevel} from '../models/ui';
import { UnsafeAction } from '../actions/UnsafeAction';
import { SortService } from "../services";

@Injectable()
export class PricelevelEffect {
	constructor(
		private updates$: Actions,
		private priceApi: PriceApi,
		private priceLevelActions: PriceLevelActions,
		private sortService: SortService
	) { }



	@Effect() loadPriceLevel$ = this.updates$
		.ofType(CategoryActions.LOAD_COLLECTION_SUCCESS)
		.map((action: UnsafeAction) => <Category[]> action.payload)
		.flatMap(categories => Observable.from(categories)
			.flatMap(category =>
				Observable.zip(
					this.priceApi.getStandardPriceLevel(category._links.standardPriceLevel.href).let(this.ignore404()).map(pl=>pl||PriceLevel.create()),
					this.priceApi.getReducedPriceLevels(category._links.reducedPriceLevels.href).let(this.ignore404()),
					(standardPrice, reducedPrices) => {
						const sortedReducedPrices = this.sortService.sort(reducedPrices, 'pos');
						return <CombinedPriceLevel>{categoryID:category.uuid, standard: standardPrice, reduced: sortedReducedPrices } }
				)
			)
			.toArray()
		)
		.map(combinedPLs => this.priceLevelActions.loadPriceLevelsSuccess(combinedPLs));



	private ignore404() {
		return  (ob:Observable<any>) => ob.catch(err=>Observable.of(null))
	}

	private updateOrCreatePricelevel() {
		return (ob: Observable<PriceLevel>) =>
			ob.flatMap(pl => pl._links ? this.priceApi.updatePrice(pl) : this.priceApi.createPrice(pl))
	}


}





// WEBPACK FOOTER //
// ./src/app/effects/pricelevel.effect.ts